export default "__VITE_ASSET__BJ0F0Sym__"